// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3glDU","newExpiryDate":"styles_newExpiryDate__1I3-l","footer":"styles_footer__3q3WO"};